interface ClientErrorInput {
  /** Kurzer Herkunfts-Bezeichner, z.B. "SectionErrorBoundary:Kennzahlen-Bereich" oder
   * "app/screener/error". */
  source: string;
  message: string;
  stack?: string;
}

/**
 * Best-effort Fehlerbericht aus einer Client-Fehlerbehandlung (SectionErrorBoundary,
 * die diversen error.tsx-Dateien) an /api/log-error - fire-and-forget, blockiert nie
 * die eigentliche Fehleranzeige und wirft selbst nie. Bewusst der Umweg über die
 * API-Route statt eines direkten Supabase-Inserts: der Service-Role-Client darf laut
 * lib/supabase/service-role.ts niemals im Browser laufen.
 */
export function reportClientError(input: ClientErrorInput): void {
  try {
    const url = typeof window !== "undefined" ? window.location.href : undefined;
    void fetch("/api/log-error", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...input, url }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Fire-and-forget - ein fehlschlagendes Logging darf nie selbst crashen.
  }
}
